import axios from 'axios';
import { REST_API_SERVER } from '../constants';
import SessionManager from '../utils/session';



const Client = axios.create({
  baseURL: REST_API_SERVER,
});


Client.interceptors.request.use(config => {

  let token = SessionManager.getAuthToken();
  if (token) {
    if(!config.headers){
      config.headers = {}
    }

    Object.assign(config.headers, {'Authorization': `Bearer ${token}`});
  }

  return config;
});

export default Client;